export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "c3cab432a0msh3dfc8c437028c1dp1a3f1djsnbc227c9ab3a1",
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};
export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
export const WEATHER_API_KEY = "a190c3ec64eaea3a97a5976e3484294e";
